import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, Renderer2, SimpleChanges } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { MessageService } from '@progress/kendo-angular-l10n';
import { IControls } from 'bi-interfaces';
import { BIModulesService } from '../../bi-modules.service';
import * as moment from 'moment';
import { ColViewService } from '../BI-Nav/col-view.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { UiProfileService } from '../../services/ui-profile.service';




type Breakpoint = 'small' | 'medium' | 'large' | 'extraLarge';
@Component({
  selector: 'bi-control-list-2col',
  templateUrl: './bi-control-list-2col.html',
  styleUrls: ['./bi-control-list-2col.scss']
})


export class biControlListin2ColComponent implements OnChanges, OnDestroy {

  public date!: moment.Moment;
  public disabled = false;
  public showSpinners = true;
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = false;
  public minDate!: moment.Moment;
  public maxDate!: moment.Moment;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;


  @Input() controlList!: IControls[];
  @Input() formGroup!: FormGroup;
  @Input() noOfRows: any;
  @Input() hasPendingChanges: boolean = false;
  @Input() AccordionName: string = '';
  @Input() ColsSizes: string[] = ['71%', '27%'];


  @Input() IsFilterable: boolean | undefined = false;
  rowsList: string[] = [];
  public ColNumberServiceSub!: Subscription
  public asFormControl(formControl: AbstractControl<any, any> | null): FormControl {
    return formControl as FormControl;
  }

  public mediaQueryLists: { [key: string]: MediaQueryList } = {};
  public mediaQueryListeners: { [key: string]: () => void } = {};
  private breakpoints: { [key in Breakpoint]: string } = {
    small: '(max-width: 600px)',
    medium: '(min-width: 601px) and (max-width: 1024px)',
    large: '(min-width: 1025px) and (max-width: 1440px)',
    extraLarge: '(min-width: 1441px)'
  };
  public matchedSize = "";
  private previousScreenSize = "";
  private columnNumber:number = 0;
  private userUIProfileSub: Subscription = new Subscription()
  constructor(
    private messages: MessageService,
    public biService: BIModulesService,
    public ColViewService: ColViewService,
    private uiProfileService: UiProfileService,
  ) {
    this.messages.notify(this.biService.getDir())
  }
  ngOnInit() {
    if (this.uiProfileService.IsUserUIProfileFilled) {
      this.determineSavedOrResponsiveLayout(this.uiProfileService.UserUIProfile.BS_CustomScreenLayout?.LayoutColumns);
    } else {
      this.userUIProfileSub = this.uiProfileService.UserUIProfileFilled$
      .subscribe(() => {
        this.determineSavedOrResponsiveLayout(this.uiProfileService.UserUIProfile.BS_CustomScreenLayout?.LayoutColumns);
        this.userUIProfileSub.unsubscribe();
      });
    }
    this.ColNumberServiceSub = this.ColViewService.ColNumber.subscribe((data: any) => {
      this.changeColumnLayout(data);
    })
  }

  private determineSavedOrResponsiveLayout(resolvedColNum: number | undefined): void {
    if (resolvedColNum) {
      this.changeColumnLayout(resolvedColNum);
    } else {
      this.setupMediaQueries();
    }
  }
  changeColumnLayout(columnNumber: any){
    this.columnNumber = columnNumber;
    this.AlterColumnNumber(columnNumber)
  }
  ngOnChanges(changes: SimpleChanges): void {}


  AlterColumnNumber(numberOfColumns: number) {
    this.controlList = this.rearrangeArray(this.controlList)
    let CurrentRow = 1
    let CurrentCol = 1
    this.controlList.forEach(el => {

      if (el.IsVisible) {
        if (el.controlType == 'title') {
          CurrentRow += 1;
          CurrentCol = 0;
        }
        el.rowNumber = CurrentRow;
        el.colNumber = CurrentCol;
        CurrentCol = (CurrentCol % numberOfColumns) + 1;
        if (CurrentCol === 1) {
          CurrentRow += 1;
        }

      }
    });
  }


  public rearrangeArray(items: any): any[] {
    return items.sort((a: any, b: any) => {
      if (a.rowNumber === b.rowNumber) {
        return a.colNumber - b.colNumber;
      } else {
        return a.rowNumber - b.rowNumber;
      }
    });
  }



public  setupMediaQueries(): void {
    Object.keys(this.breakpoints).forEach((size) => {
      const key = size as Breakpoint;
      this.mediaQueryLists[size] = window.matchMedia(this.breakpoints[key]);

      this.mediaQueryListeners[size] = () => {
        this.handleMediaQueryChange();
        this.columnNumber = 0;
      };

      this.mediaQueryLists[size].addEventListener(
        'change',
        this.mediaQueryListeners[size]
      );
      this.handleMediaQueryChange(); // Initial check
    });
  }

  public handleMediaQueryChange(): void {

    Object.keys(this.mediaQueryLists).forEach((size) => {
      if (this.mediaQueryLists[size].matches) {
        this.matchedSize = size;
      }
    });
    if( this.previousScreenSize != this.matchedSize){
      this.checkMatchedSize();
    }
    this.previousScreenSize = this.matchedSize;
  }

  public reArrangeColumns(): void {
    if(this.columnNumber != 0){
      this.AlterColumnNumber(this.columnNumber);
      return
    }
    this.checkMatchedSize();
    this.previousScreenSize = this.matchedSize;
  }

  checkMatchedSize(){
    if (this.matchedSize == 'small' ) {
      this.AlterColumnNumber(1)
    } else if (this.matchedSize == 'medium' ) {
      this.AlterColumnNumber(2)
    } else if (this.matchedSize == 'large') {
      this.AlterColumnNumber(4)
    }
    else if (this.matchedSize == 'extraLarge' ) {
      this.AlterColumnNumber(4)
    }
  }

  ngOnDestroy() {
    this.ColNumberServiceSub.unsubscribe();
    Object.keys(this.mediaQueryLists).forEach((size) => {
      this.mediaQueryLists[size].removeEventListener(
        'change',
        this.mediaQueryListeners[size]
      );
    });

  }
}
